export const maleHeroes = [
  // [일반 등급 - 단일 특화]
  {
    id: "m_s_1",
    name: "철혈의 소드마스터",
    rank: "일반",
    type: "S",
    image: "/images/m_s_1.jpg",
    description: "압도적인 근력으로 대검을 휘두르며 전열을 파괴합니다. 당신의 사전에는 후퇴란 없습니다.",
    strengths: ["불굴의 의지", "강력한 추진력", "우직한 정직함"],
    weakness: ["지적 탐구심 부족", "세밀한 소통의 부재"],
    advice: "강한 힘은 때로 주변을 살피지 못하게 합니다. 가끔은 검을 내려놓고 타인의 지혜를 빌려보세요.",
    skills: ["기사도", "지면 강타", "불굴의 투지"],
    weapon: "드래곤 슬레이어 대검",
    partner: "태양의 대사제",
    glowColor: "#ff4d4d"
  },
  {
    id: "m_m_1",
    name: "금단의 대마도사",
    rank: "일반",
    type: "M",
    image: "/images/m_m_1.jpg",
    description: "세상의 원소를 통달한 지혜의 탐구자입니다. 당신의 지식은 곧 가장 강력한 무기가 됩니다.",
    strengths: ["탁월한 분석력", "높은 지적 호기심", "냉철한 상황 판단"],
    weakness: ["현실적인 실행력 부족", "다소 냉소적인 태도"],
    advice: "머릿속의 완벽한 계획보다 한 번의 서툰 실행이 세상을 바꿀 때가 있습니다. 현장에서 답을 찾아보세요.",
    skills: ["메테오 스트라이크", "마력 역류", "현자의 눈"],
    weapon: "세계수 지팡이",
    partner: "비전의 마법학자",
    glowColor: "#4d94ff"
  },
  {
    id: "m_a_1",
    name: "그림자 암살자",
    rank: "일반",
    type: "A",
    image: "/images/m_a_1.jpg",
    description: "소리 없이 다가가 심장을 꿰뚫는 밤의 지배자입니다. 어둠 속에서 가장 빛나는 존재입니다.",
    strengths: ["기민한 적응력", "핵심을 파고드는 순발력", "독립적인 해결 능력"],
    weakness: ["타인에 대한 낮은 신뢰", "장기적 끈기 부족"],
    advice: "혼자서 모든 것을 해결하려 하지 마세요. 그림자 밖으로 나와 동료의 손을 잡는 법을 배워야 합니다.",
    skills: ["은신", "독니 발도", "그림자 복제"],
    weapon: "흑요석 단검",
    partner: "은빛 바람의 궁수",
    glowColor: "#a64dff"
  },
  {
    id: "m_f_1",
    name: "대성당의 수호성인",
    rank: "일반",
    type: "F",
    image: "/images/m_f_1.jpg",
    description: "신의 대리인으로서 아군을 보호하는 성스러운 방패입니다. 당신의 기도는 절망을 희망으로 바꿉니다.",
    strengths: ["깊은 공감 능력", "도덕적 청렴함", "희생정신"],
    weakness: ["낮은 자기 주장", "결단력 부족"],
    advice: "모두를 구하려다 정작 자신을 잃을 수 있습니다. 때로는 타인의 요청에 단호하게 거절하는 용기가 필요합니다.",
    skills: ["신의 가호", "정화의 빛", "천상의 방패"],
    weapon: "미스릴 메이스",
    partner: "전장의 여제 발키리",
    glowColor: "#ffff99"
  },

  // [희귀 등급 - 복합 조합]
  {
    id: "m_sm_1",
    name: "마검사",
    rank: "희귀",
    type: "S+M",
    image: "/images/m_sm_1.jpg",
    description: "검술과 마법의 경계를 허무는 변칙적인 전투의 달인입니다. 다재다능함이 당신의 상징입니다.",
    strengths: ["균형 잡힌 시야", "다양한 문제 해결 능력", "창의적 도전"],
    weakness: ["한 분야의 전문성 부족", "쉽게 실증을 느끼는 성향"],
    advice: "다재다능함은 독이 될 수도 있습니다. 하나를 끝까지 파고드는 집중력을 기른다면 무적이 될 것입니다.",
    skills: ["속성 인챈트", "마력 참격", "잔상 검무"],
    weapon: "룬 인챈트 롱소드",
    partner: "스펠 블레이드",
    glowColor: "#ff00ff"
  },
  {
    id: "m_sa_1",
    name: "전투 도적",
    rank: "희귀",
    type: "S+A",
    image: "/images/m_sa_1.jpg",
    description: "힘과 속도를 동시에 갖춰 거칠게 몰아치는 무법자입니다. 야생의 본능이 살아있습니다.",
    strengths: ["압도적 승부욕", "빠른 행동력", "현장 적응력"],
    weakness: ["계획성 부족", "공격적인 의사소통"],
    advice: "행동하기 전 딱 3초만 더 생각하세요. 당신의 열정에 신중함이 더해지면 전설이 됩니다.",
    skills: ["폭풍 난사", "급소 포착", "강철 회전"],
    weapon: "쌍날 도끼단검",
    partner: "와일드 헌터",
    glowColor: "#ff8c00"
  },
  {
    id: "m_sf_1",
    name: "성기사",
    rank: "희귀",
    type: "S+F",
    image: "/images/m_sf_1.jpg",
    description: "굳건한 신념을 위해 검을 듭니다. 고결한 정신과 육체적 강인함을 겸비했습니다.",
    strengths: ["투철한 책임감", "정의로운 리더십", "안정감"],
    weakness: ["완고한 원칙주의", "융통성 없는 태도"],
    advice: "세상에는 흑과 백만 있는 것이 아닙니다. 회색빛 다양성을 인정할 때 당신의 그늘 아래 더 많은 사람이 모일 것입니다.",
    skills: ["심판의 망치", "희생의 오라", "성스러운 돌격"],
    weapon: "엑스칼리버 복제품",
    partner: "빛의 기사단장",
    glowColor: "#ffd700"
  },
  {
    id: "m_ma_1",
    name: "환술사",
    rank: "희귀",
    type: "M+A",
    image: "/images/m_ma_1.jpg",
    description: "환영과 기동성으로 적을 기만합니다. 보이지 않는 곳에서 판을 짜는 전략가입니다.",
    strengths: ["유연한 사고", "상대방의 심리 파악", "탁월한 전략"],
    weakness: ["불투명한 태도", "솔직한 감정 표현의 두려움"],
    advice: "때로는 정면승부가 가장 빠른 길일 수 있습니다. 자신의 본심을 드러내는 것을 두려워하지 마세요.",
    skills: ["미러 이미지", "차원 도약", "혼돈의 비구름"],
    weapon: "환영의 카드",
    partner: "밤의 무희",
    glowColor: "#00ced1"
  },
  {
    id: "m_mf_1",
    name: "현자",
    rank: "희귀",
    type: "M+F",
    image: "/images/m_mf_1.jpg",
    description: "마법과 신성력을 동시에 다루며 고난에 빠진 이들을 인도하는 중재자입니다.",
    strengths: ["깊은 성찰", "평화주의적 리더십", "포용력"],
    weakness: ["지나친 이상주의", "현실적 이익 계산 부족"],
    advice: "이상은 높되 발은 땅을 딛고 있어야 합니다. 구체적인 실행 방안을 고민하는 습관을 가져보세요.",
    skills: ["우주의 섭리", "광휘의 폭발", "영혼의 안식"],
    weapon: "고대 예언서",
    partner: "천상의 오라클",
    glowColor: "#ffffff"
  },
  {
    id: "m_af_1",
    name: "심판관",
    rank: "희귀",
    type: "A+F",
    image: "/images/m_af_1.jpg",
    description: "신의 뜻을 받들어 보이지 않는 곳에서 악을 처단하는 자비 없는 심판자입니다.",
    strengths: ["날카로운 통찰력", "철저한 자기 관리", "사명감"],
    weakness: ["지나친 자기 비판", "인간미 없는 태도"],
    advice: "당신 자신에게도 자비를 베푸세요. 완벽하지 않아도 괜찮다는 사실을 인정할 때 진정한 평안이 옵니다.",
    skills: ["징벌의 화살", "빛의 추적", "단죄의 올가미"],
    weapon: "성수 뿌린 쇠뇌",
    partner: "달빛 암살자",
    glowColor: "#b0c4de"
  },
  {
    id: "m_sma_1",
    name: "드래곤 슬레이어",
    rank: "희귀",
    type: "S+M+A",
    image: "/images/m_sma_1.jpg",
    description: "용의 심장을 꿰뚫을 힘과 마력, 속도를 모두 갖춘 전설적인 영웅입니다.",
    strengths: ["탁월한 성취욕", "위기 돌파 능력", "카리스마"],
    weakness: ["지나친 승부욕", "동료에 대한 과도한 기대"],
    advice: "혼자서 너무 멀리 가버리면 동료들이 따라올 수 없습니다. 함께 발맞춰 걷는 법을 잊지 마세요.",
    skills: ["용언 살해", "화염 면역", "최후의 일격"],
    weapon: "용의 비늘 창",
    partner: "미스릴 마스터",
    glowColor: "#ff4500"
  },
  {
    id: "m_smf_1",
    name: "룬 워리어",
    rank: "희귀",
    type: "S+M+F",
    image: "/images/m_smf_1.jpg",
    description: "고대 문자의 힘을 몸에 새긴 불멸의 투사입니다. 물리와 마법 방어가 완벽합니다.",
    strengths: ["단단한 자아", "철저한 원칙 수행", "신중함"],
    weakness: ["새로운 변화에 대한 거부감", "감정 소모를 극도로 꺼림"],
    advice: "새로운 변화는 위협이 아니라 기회입니다. 때로는 자신의 틀을 깨고 밖으로 나오는 용기가 필요합니다.",
    skills: ["룬의 결계", "속성 강화", "대지 가르기"],
    weapon: "룬 문자가 새겨진 워해머",
    partner: "고결한 성녀",
    glowColor: "#4682b4"
  },
  {
    id: "m_saf_1",
    name: "그림자 기사",
    rank: "희귀",
    type: "S+A+F",
    image: "/images/m_saf_1.jpg",
    description: "어둠의 힘으로 빛을 수호하며 고독한 길을 걷는 수호자입니다.",
    strengths: ["침묵 속의 실천", "헌신적인 태도", "강한 내면"],
    weakness: ["외로움에 익숙함", "자신의 공로를 숨김"],
    advice: "당신의 노고를 세상이 알게 하세요. 빛 아래서 칭찬받을 자격이 충분합니다.",
    skills: ["심연의 가시", "그림자 치유", "황혼의 습격"],
    weapon: "칠흑의 클레이모어",
    partner: "바람의 정령사",
    glowColor: "#2f4f4f"
  },
  {
    id: "m_maf_1",
    name: "비전 저격수",
    rank: "희귀",
    type: "M+A+F",
    image: "/images/m_maf_1.jpg",
    description: "멀리서 마력 화살로 적의 영혼을 조준합니다. 시야 밖의 진실을 꿰뚫어 봅니다.",
    strengths: ["정교한 집중력", "장기적 전망", "침착함"],
    weakness: ["가까운 사람에 대한 소홀함", "세세한 현실 감각 부족"],
    advice: "멀리 있는 목표만큼이나 발밑의 소중한 사람들을 돌보세요. 일상의 작은 행복이 큰 힘이 됩니다.",
    skills: ["영혼 관통", "마나 추적", "공간 왜곡 사격"],
    weapon: "아스트랄 보우",
    partner: "아스트랄 위치",
    glowColor: "#9370db"
  },
  {
    id: "m_bal_1",
    name: "방랑자",
    rank: "희귀",
    type: "S,M,A,F 균등",
    image: "/images/m_bal_1.jpg",
    description: "모든 재능을 골고루 꽃피운 모험가입니다. 어디서든 살아남는 적응력의 왕입니다.",
    strengths: ["탁월한 균형 감각", "높은 개방성", "다양한 경험"],
    weakness: ["결정적 한 방의 부재", "방향성 상실 가능성"],
    advice: "어디든 갈 수 있다는 것은 어디로 가야 할지 모른다는 뜻이기도 합니다. 당신만의 북극성을 정해보세요.",
    skills: ["다재다능", "임기응변", "전술적 후퇴"],
    weapon: "낡은 모험가의 검",
    partner: "운명의 개척자",
    glowColor: "#8b4513"
  },
  {
    id: "m_ms_1",
    name: "강철의 연금술사",
    rank: "희귀",
    type: "M+S",
    image: "/images/m_ms_1.jpg",
    description: "물질의 법칙을 재구성하여 전장을 조작하는 냉철한 천재입니다.",
    strengths: ["논리적 사고", "효율성 극대화", "탐구 정신"],
    weakness: ["감정보다 논리 우선", "결과 중심적 사고"],
    advice: "사람의 마음은 논리로 풀 수 있는 연금술이 아닙니다. 비논리적인 감정의 가치를 인정해 보세요.",
    skills: ["등가교환", "지형 변환", "금속 강화"],
    weapon: "연금술 건틀릿",
    partner: "빙결의 여왕",
    glowColor: "#708090"
  },

  // [전설 등급 - 초월자]
  {
    id: "m_legend_1",
    name: "시공의 지배자",
    rank: "전설",
    type: "ALL MAX",
    image: "/images/m_legend_1.jpg",
    description: "시간과 공간을 초월하여 우주의 질서를 다스리는 자입니다.",
    strengths: ["초월적 통찰", "절대적 리더십", "완성된 자아"],
    weakness: ["인간적인 유대감 결여", "지나친 완벽주의"],
    advice: "모든 것을 통제할 필요는 없습니다. 때로는 우연과 혼돈에 몸을 맡길 때 진정한 자유를 얻습니다.",
    skills: ["시간 정지", "차원 붕괴", "운명 재기록"],
    weapon: "우주의 지팡이",
    partner: "영겁의 성모",
    glowColor: "#ffd700"
  },
  {
    id: "m_legend_2",
    name: "종언의 파괴신",
    rank: "전설",
    type: "S/M Extreme",
    image: "/images/m_legend_2.jpg",
    description: "모든 생명체를 무(無)로 돌릴 수 있는 파괴와 재탄생의 화신입니다.",
    strengths: ["혁명적인 변화 추진력", "압도적 카리스마", "한계 돌파"],
    weakness: ["파괴적 성향", "타협하지 않는 극단성"],
    advice: "파괴는 창조의 어머니이지만, 사랑 없는 파괴는 허무만을 남깁니다. 당신의 힘을 지탱할 따스한 동기를 찾으세요.",
    skills: ["종말의 숨결", "무(無)의 공간", "신성 모독"],
    weapon: "멸망의 낫",
    partner: "카오스 발키리",
    glowColor: "#000000"
  }
];
export const femaleHeroes = [
  // [일반 등급 - 단일 특화]
  {
    id: "f_s_1",
    name: "전장의 여제 발키리",
    rank: "일반",
    type: "S",
    image: "/images/f_s_1.jpg",
    description: "죽은 자들의 영혼을 인도하는 고결한 여전사입니다. 당신의 창이 지면을 두드리면 전장의 모든 적이 공포에 떱니다.",
    strengths: ["강인한 정신력", "주도적인 리더십", "위기 앞의 대범함"],
    weakness: ["타인의 도움을 거절함", "감정적 취약함을 숨김"],
    advice: "혼자서 모든 짐을 지려 하지 마세요. 당신의 약점까지 보여줄 수 있을 때 진정한 동료를 얻게 될 것입니다.",
    skills: ["발할라의 부름", "심판의 투창", "불멸의 날개"],
    weapon: "궁니르의 파편 창",
    partner: "대성당의 수호성인",
    glowColor: "#ff3333"
  },
  {
    id: "f_m_1",
    name: "비전의 마법학자",
    rank: "일반",
    type: "M",
    image: "/images/f_m_1.jpg",
    description: "차원의 틈새에서 금지된 진리를 깨우쳤습니다. 당신의 지식은 현실의 법칙조차 재정립합니다.",
    strengths: ["탁월한 논리력", "창의적 문제해결", "무한한 상상력"],
    weakness: ["현실적인 세부사항 소홀", "냉정해 보이는 첫인상"],
    advice: "지식은 나누어야 가치가 있습니다. 당신의 높은 통찰을 이해하기 쉬운 언어로 주변과 공유해 보세요.",
    skills: ["아르카나 폭발", "차원 왜곡", "무한의 마나"],
    weapon: "은하수의 보주",
    partner: "금단의 대마도사",
    glowColor: "#33ccff"
  },
  {
    id: "f_a_1",
    name: "은빛 바람의 궁수",
    rank: "일반",
    type: "A",
    image: "/images/f_a_1.jpg",
    description: "바람보다 빠르게 화살을 날리는 숲의 감시자입니다. 단 한 번의 조준으로 운명을 결정짓습니다.",
    strengths: ["예리한 집중력", "뛰어난 관찰력", "독립적인 생활 방식"],
    weakness: ["변화에 대한 불안감", "신중함 때문에 놓치는 기회"],
    advice: "때로는 조준하기 전에 활시위를 당겨야 할 때도 있습니다. 완벽한 순간을 기다리기보다 흐름에 몸을 맡겨보세요.",
    skills: ["질풍의 화살", "바람의 걸음", "정밀 저격"],
    weapon: "엘프 여왕의 활",
    partner: "그림자 암살자",
    glowColor: "#33ff99"
  },
  {
    id: "f_f_1",
    name: "태양의 대사제",
    rank: "일반",
    type: "F",
    image: "/images/f_f_1.jpg",
    description: "자애로운 빛으로 모든 상처를 치유하는 성녀입니다. 당신은 절망적인 상황에서도 희망의 씨앗을 찾아냅니다.",
    strengths: ["이타적인 배려", "평화를 만드는 소통", "긍정적인 에너지"],
    weakness: ["거절하지 못하는 성격", "자기 희생적 성향"],
    advice: "남을 돌보기 전에 자신의 마음부터 돌보세요. 당신의 빛이 꺼지면 구원할 수 있는 사람도 사라집니다.",
    skills: ["태양의 가호", "성스러운 치유", "부활의 권능"],
    weapon: "태양신의 성석",
    partner: "철혈의 소드마스터",
    glowColor: "#ffeb3b"
  },

  // [희귀 등급 - 복합 조합]
  {
    id: "f_sm_1",
    name: "스펠 블레이드",
    rank: "희귀",
    type: "S+M",
    image: "/images/f_sm_1.jpg",
    description: "검무 속에 마법을 숨긴 전장의 예술가입니다. 화려함과 실용성을 동시에 갖춘 능력자입니다.",
    strengths: ["융합적인 사고", "예술적 감각", "빠른 습득력"],
    weakness: ["산만한 관심사", "깊이 있는 인내심 부족"],
    advice: "여러 우물을 파기보다 하나의 우물에서 깊은 물을 길어 올리는 끈기를 길러보세요.",
    skills: ["서리불꽃 검무", "마력 중첩", "환영 돌격"],
    weapon: "크리스탈 레이피어",
    partner: "마검사",
    glowColor: "#ff007f"
  },
  {
    id: "f_sa_1",
    name: "와일드 헌터",
    rank: "희귀",
    type: "S+A",
    image: "/images/f_sa_1.jpg",
    description: "맹수와 교감하며 전장을 누비는 야성의 사냥꾼입니다. 길들여지지 않는 자유로운 영혼입니다.",
    strengths: ["강한 자생력", "직관적인 판단", "충성심"],
    weakness: ["규율과 형식에 대한 거부", "다소 거친 표현 방식"],
    advice: "자유로움 속에 체계를 더해 보세요. 사회적 규칙을 조금만 활용한다면 당신의 능력은 더 넓게 쓰일 것입니다.",
    skills: ["야수의 맹공", "함정 설치", "동료 소환"],
    weapon: "가시 박힌 채찍창",
    partner: "전투 도적",
    glowColor: "#8bc34a"
  },
  {
    id: "f_sf_1",
    name: "빛의 기사단장",
    rank: "희귀",
    type: "S+F",
    image: "/images/f_sf_1.jpg",
    description: "꺾이지 않는 정의감으로 왕국을 지키는 여장군입니다. 당신은 존재만으로 타인에게 신뢰를 줍니다.",
    strengths: ["확고한 윤리관", "강력한 리더십", "안정적인 추진력"],
    weakness: ["지나치게 보수적인 태도", "자신에 대한 엄격함"],
    advice: "자신에게 조금 더 관대해지세요. 당신이 행복해야 당신이 지키는 세상도 비로소 평화로워집니다.",
    skills: ["기사단의 자부심", "성스러운 돌진", "정의의 구역"],
    weapon: "황금빛 롱소드",
    partner: "성기사",
    glowColor: "#ffa000"
  },
  {
    id: "f_ma_1",
    name: "밤의 무희",
    rank: "희귀",
    type: "M+A",
    image: "/images/f_ma_1.jpg",
    description: "몽환적인 춤사위로 적의 정신을 빼앗습니다. 보이지 않는 곳에서 매력을 발산하는 전략가입니다.",
    strengths: ["매혹적인 소통", "유연한 사고방식", "심리 분석"],
    weakness: ["진실을 감추는 성향", "피상적인 관계 맺기"],
    advice: "가면 뒤의 진심을 보여줄 용기를 가지세요. 진정한 유대는 화려한 기술이 아닌 진실함에서 나옵니다.",
    skills: ["몽환의 춤", "그림자 이동", "감각 마비"],
    weapon: "은색 비단 부채",
    partner: "환술사",
    glowColor: "#7b1fa2"
  },
  {
    id: "f_mf_1",
    name: "천상의 오라클",
    rank: "희귀",
    type: "M+F",
    image: "/images/f_mf_1.jpg",
    description: "미래를 예지하고 신성한 계시를 내립니다. 당신의 지혜는 시간을 앞서갑니다.",
    strengths: ["영적인 통찰", "포용적인 마음", "거시적인 안목"],
    weakness: ["지나친 사색적 성향", "현실적 감각의 결여"],
    advice: "미래를 보는 것보다 중요한 것은 지금 이 순간을 사는 것입니다. 현재의 소소한 일상에 집중해 보세요.",
    skills: ["운명의 예언", "천상의 심판", "정신적 연결"],
    weapon: "별의 파편 수정구",
    partner: "현자",
    glowColor: "#e1f5fe"
  },
  {
    id: "f_af_1",
    name: "달빛 암살자",
    rank: "희귀",
    type: "A+F",
    image: "/images/f_af_1.jpg",
    description: "달의 은총을 받아 어둠 속에서 심판을 내립니다. 조용하지만 가장 확실한 개혁가입니다.",
    strengths: ["철저한 자기 절제", "목표 지향적", "겸손함"],
    weakness: ["과도한 책임감에 의한 고립", "부정적 감정의 억제"],
    advice: "슬픔이나 화를 표현하는 것은 약함이 아닙니다. 감정을 표출할 수 있는 건강한 통로를 찾아보세요.",
    skills: ["그믐달 베기", "정적의 가루", "신의 추적"],
    weapon: "초승달 쌍단검",
    partner: "심판관",
    glowColor: "#cfd8dc"
  },
  {
    id: "f_sma_1",
    name: "미스릴 마스터",
    rank: "희귀",
    type: "S+M+A",
    image: "/images/f_sma_1.jpg",
    description: "전설의 금속을 다루는 병기 전문가입니다. 당신의 손에서 불가능한 것은 현실이 됩니다.",
    strengths: ["완벽한 기술력", "현실적인 실행력", "강한 자립심"],
    weakness: ["타인의 조언을 무시함", "감성적인 소통 부재"],
    advice: "때로는 미완성의 아름다움도 인정해 보세요. 모든 것을 완벽하게 통제하려는 강박에서 벗어나면 더 큰 창의성이 생깁니다.",
    skills: ["금속 재구성", "무기 투척", "미스릴 장갑"],
    weapon: "미스릴 멀티웨폰",
    partner: "드래곤 슬레이어",
    glowColor: "#607d8b"
  },
  {
    id: "f_smf_1",
    name: "고결한 성녀",
    rank: "희귀",
    type: "S+M+F",
    image: "/images/f_smf_1.jpg",
    description: "파괴와 치유를 동시에 행하는 전장의 어머니입니다. 당신은 질서와 사랑의 상징입니다.",
    strengths: ["압도적인 포용력", "강한 신념", "안정적인 영향력"],
    weakness: ["주변에 대한 높은 기대", "변화하는 환경에 대한 두려움"],
    advice: "모두를 만족시킬 수는 없습니다. 타인의 비난에 흔들리지 말고 당신만의 중심을 유지하세요.",
    skills: ["자애의 폭풍", "생명의 꽃", "신성한 폭발"],
    weapon: "치유의 장검",
    partner: "룬 워리어",
    glowColor: "#f8bbd0"
  },
  {
    id: "f_saf_1",
    name: "바람의 정령사",
    rank: "희귀",
    type: "S+A+F",
    image: "/images/f_saf_1.jpg",
    description: "정령들과 소통하며 자연의 힘을 빌립니다. 당신은 주변을 활기차게 만드는 생명의 통로입니다.",
    strengths: ["친화력과 유연함", "순수한 에너지", "공감력"],
    weakness: ["집중력의 분산", "어려운 결정의 회피"],
    advice: "바람은 자유롭지만 가끔은 닻을 내려야 할 때가 있습니다. 꼭 해야만 하는 일에는 끝까지 책임지는 힘을 기르세요.",
    skills: ["정령의 속삭임", "대기의 벽", "자연의 복수"],
    weapon: "정령 깃든 단궁",
    partner: "그림자 기사",
    glowColor: "#c8e6c9"
  },
  {
    id: "f_maf_1",
    name: "아스트랄 위치",
    rank: "희귀",
    type: "M+A+F",
    image: "/images/f_maf_1.jpg",
    description: "별자리와 소통하여 우주의 에너지를 사용하는 신비로운 마녀입니다.",
    strengths: ["거대한 비전", "비범한 지적 능력", "독창성"],
    weakness: ["일상적인 관계에 대한 무관심", "지나친 자부심"],
    advice: "밤하늘의 별만큼이나 당신 옆의 사람들도 소중합니다. 아주 작은 일상부터 소통을 시작해 보세요.",
    skills: ["유성우", "별의 결계", "은하수 도약"],
    weapon: "점성술사의 천구의",
    partner: "비전 저격수",
    glowColor: "#d1c4e9"
  },
  {
    id: "f_bal_1",
    name: "운명의 개척자",
    rank: "희귀",
    type: "S,M,A,F 균등",
    image: "/images/f_bal_1.jpg",
    description: "정해진 운명을 거부하고 스스로의 길을 만드는 전설의 모험가입니다.",
    strengths: ["탁월한 적응성", "두려움 없는 도전", "자기 주도성"],
    weakness: ["지나친 독립성(독불장군)", "한 곳에 정착하지 못함"],
    advice: "때로는 누군가에게 기대는 것도 용기입니다. 혼자 개척하는 길도 좋지만, 함께 만드는 공동체의 소중함을 경험해 보세요.",
    skills: ["한계 돌파", "모험가의 지혜", "운명의 개혁"],
    weapon: "주인 없는 전설의 검",
    partner: "방랑자",
    glowColor: "#a1887f"
  },
  {
    id: "f_ms_1",
    name: "빙결의 여왕",
    rank: "희귀",
    type: "M+S",
    image: "/images/f_ms_1.jpg",
    description: "모든 것을 얼어붙게 만드는 절대 영도의 지배자입니다. 냉철한 카리스마를 지녔습니다.",
    strengths: ["엄격한 자기 절제", "정확한 판단력", "강력한 통제력"],
    weakness: ["인색한 감정 표현", "사람들과의 정서적 거리감"],
    advice: "당신의 얼음 성벽은 자신을 보호하기도 하지만, 사랑을 막기도 합니다. 따뜻한 온기가 스며들 틈을 열어주세요.",
    skills: ["절대 영도", "얼음 가시", "서리 요새"],
    weapon: "만년설 지팡이",
    partner: "강철의 연금술사",
    glowColor: "#e1f5fe"
  },

  // [전설 등급 - 초월자]
  {
    id: "f_legend_1",
    name: "영겁의 성모",
    rank: "전설",
    type: "ALL MAX",
    image: "/images/f_legend_1.jpg",
    description: "모든 생명의 근원이며 영원한 평화를 상징하는 초월적인 존재입니다.",
    strengths: ["무조건적인 수용", "완성된 통찰", "전지적 리더십"],
    weakness: ["인간적인 욕구의 상실", "초월적 존재로서의 소외감"],
    advice: "완벽한 존재가 될 필요는 없습니다. 때로는 실수하고 아파하는 인간적인 모습이 더 큰 위로가 됩니다.",
    skills: ["창조의 숨결", "영원한 안식", "구원의 빛"],
    weapon: "생명의 근원 지팡이",
    partner: "시공의 지배자",
    glowColor: "#ffffff"
  },
  {
    id: "f_legend_2",
    name: "카오스 발키리",
    rank: "전설",
    type: "S/M Extreme",
    image: "/images/f_legend_2.jpg",
    description: "혼돈 속에서 태어나 질서를 재정립하는 전쟁의 신입니다. 파괴를 통해 새로운 창조를 이끕니다.",
    strengths: ["폭발적인 창조력", "한계를 모르는 에너지", "직관적 통찰"],
    weakness: ["감정 기복의 극단성", "파괴적인 성향"],
    advice: "당신의 힘을 부수기보다 세우는 데 더 많이 사용하세요. 혼돈 속에서도 당신이 지켜야 할 '하나의 진실'을 잊지 마세요.",
    skills: ["혼돈의 창", "질서의 종말", "재생의 불꽃"],
    weapon: "심연의 발키리 창",
    partner: "종언의 파괴신",
    glowColor: "#000000"
  }
];